import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import { Box, Stack, Typography } from '@mui/material';

import { Block } from 'components/page';
import { PreenchimentoExportarRelatorioBtn } from 'pages/financeiro/dre/preenchimento/components';

export function PreenchimentoPainelExportacao() {
    return (
        <Block>
            <Stack direction="row" alignItems="center" sx={{ gap: 2 }} flexWrap="wrap">
                <Box sx={{ flex: 1, display: 'inherit', alignItems: 'inherit' }}>
                    <TableViewOutlinedIcon color="primary" />

                    <Typography sx={{ ml: 2, mr: 1 }}>RELATÓRIOS REFERENTES AO PERÍODO SELECIONADO</Typography>

                    <ChevronRightOutlinedIcon color="primary" />
                </Box>

                <PreenchimentoExportarRelatorioBtn />
            </Stack>
        </Block>
    );
}
